import React from 'react'

export default function CardSdm({icons,title,counter}) {
  return (
    <div className="flex items-center justify-center shadow-lg space-x-5  px-12 py-9 font-bold text-center bg-white rounded-2xl h-[170px]">
      <div className="w-14 h-14">
        <img src={icons} alt={title} width={92} height={95} />
      </div>
      <div className='space-y-2'>
        <h1>{title}</h1>
        <h1>{counter}</h1>
      </div>
    </div>
  );
}
